module.exports = __webpack_public_path__ + "img/background_2.782bbf14.webp";